/*
  Archivio Or.nami: un solo cassetto aperto per volta, e l'apertura ha
  un'altezza animata.

  Il markup e' `<details>`, quindi apre, chiude e risponde alla tastiera anche
  senza questo file. Qui si aggiungono due cose: l'esclusivita' e il movimento.
  Se il JS non arriva, l'archivio resta usabile e si possono aprire piu'
  cassetti, che apriranno di scatto - una degradazione accettabile, mentre
  costruire l'accordion da zero renderebbe la pagina inservibile al primo
  errore.

  Due cassetti aperti insieme allungano la pagina e tolgono al gesto il suo
  significato fisico: una cassettiera si apre un cassetto alla volta.
*/
(function () {
  var archivio = document.querySelector('[data-archivio]');
  if (!archivio) return;

  var cassetti = [].slice.call(archivio.querySelectorAll('[data-cassetto]'));
  if (!cassetti.length) return;

  var APRE = 320;
  var CHIUDE = 240;
  var CURVA = 'cubic-bezier(.22, 1, .36, 1)';

  function motoRidotto() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // L'altezza della pagina e' appena cambiata: senza avvisare Locomotive, il
  // limite di scorrimento resta quello di prima e il fondo pagina diventa
  // irraggiungibile.
  function aggiorna() {
    if (typeof scroll !== 'undefined' && scroll && typeof scroll.update === 'function') {
      scroll.update();
    }
  }

  function corpoDi(det) { return det.querySelector('.ornami-cassetto__corpo'); }

  // Locomotive possiede lo scorrimento quando c'e': correggerlo con
  // `window.scrollBy` non avrebbe effetto, perche' il documento non scorre.
  function loco() {
    return (typeof scroll !== 'undefined' && scroll && scroll.scroll &&
            scroll.scroll.instance && typeof scroll.scrollTo === 'function');
  }

  var inCorso = {};

  function anima(det, da, a, durata, fine) {
    var corpo = corpoDi(det);
    if (!corpo) { fine(); return; }

    var vecchia = inCorso[det.dataset.chiave];
    if (vecchia) { vecchia.cancel(); }

    if (motoRidotto()) { fine(); aggiorna(); return; }

    corpo.style.overflow = 'hidden';
    var a2 = corpo.animate(
      [{ height: da, opacity: da === '0px' ? 0 : 1 },
       { height: a,  opacity: a  === '0px' ? 0 : 1 }],
      { duration: durata, easing: CURVA }
    );
    inCorso[det.dataset.chiave] = a2;
    a2.onfinish = function () {
      inCorso[det.dataset.chiave] = null;
      corpo.style.overflow = '';
      fine();
      aggiorna();
    };
    a2.oncancel = function () { inCorso[det.dataset.chiave] = null; };
    aggiorna();
  }

  /*
    L'ALTEZZA DA CUI PARTIRE E' QUELLA CHE SI VEDE, non quella a regime.

    Sia apri() sia chiudi() leggevano `scrollHeight`, cioe' l'altezza del
    contenuto disteso, che ignora l'animazione in volo. Invertire il gesto a
    meta' corsa faceva quindi SALTARE il cassetto all'altezza piena prima di
    ripartire nella direzione nuova: su un elenco dove si apre e si chiude di
    continuo e' lo scatto piu' visibile della pagina.

    Qui si legge l'altezza resa in questo istante. Se un'animazione e' in
    corso, e' l'altezza intermedia; se non c'e', coincide con quella a regime,
    quindi il caso normale non cambia. La durata si accorcia in proporzione a
    quanto resta da percorrere: invertire a un quarto di strada deve costare
    un quarto del tempo, altrimenti il ritorno si trascina.
  */
  function altezzaResa(corpo) {
    return corpo ? Math.round(corpo.getBoundingClientRect().height) : 0;
  }

  function durataParziale(piena, da, a, intero) {
    if (!piena) return intero;
    var quota = Math.abs(da - a) / piena;
    if (quota > 1) quota = 1;
    var d = Math.round(intero * quota);
    return d < 90 ? 90 : d;   // sotto i 90ms il movimento non si legge piu'
  }

  function apri(det) {
    // Il contenuto deve esistere prima di poterlo misurare.
    var giaAperto = det.open;
    det.open = true;
    var corpo = corpoDi(det);
    if (!corpo) return;
    var piena = corpo.scrollHeight;
    var da = giaAperto ? altezzaResa(corpo) : 0;
    anima(det, da + 'px', piena + 'px',
          durataParziale(piena, da, piena, APRE), function () {});
  }

  function chiudi(det) {
    var corpo = corpoDi(det);
    if (!corpo) { det.open = false; return; }
    var piena = corpo.scrollHeight;
    var da = altezzaResa(corpo);
    // L'attributo si toglie solo a fine animazione, altrimenti il contenuto
    // sparirebbe nel primo fotogramma e non ci sarebbe nulla da animare.
    anima(det, da + 'px', '0px',
          durataParziale(piena, da, 0, CHIUDE),
          function () { det.open = false; });
  }

  function correggiDi(delta) {
    if (!delta) return;
    if (loco()) {
      var y = scroll.scroll.instance.scroll.y + delta;
      scroll.scrollTo(y < 0 ? 0 : y, { duration: 0, disableLerp: true });
    } else {
      window.scrollBy(0, delta);
    }
  }

  /*
    LA COMPENSAZIONE DEVE SEGUIRE L'ANIMAZIONE, non guardarla una volta sola.

    Il primo rimedio leggeva lo scarto dentro UN solo `requestAnimationFrame`,
    cioe' a circa 16ms di un'animazione lunga fino a 240ms su una curva
    fortemente anticipata. A 16ms l'altezza si e' mossa di poco, quindi
    correggeva di poco: circa un terzo, e il resto scorreva via lo stesso.

    Peggio: la verifica di allora aveva dato "spostamento 0" e sembrava
    risolto. Era un falso verde dell'ambiente - con `requestAnimationFrame`
    sospeso (pannello del browser nascosto) la callback non partiva a 16ms ma
    ad animazione conclusa, quando lo scarto era ormai l'intero. In un browser
    vero il cassetto scivolava ancora.

    Ora e' un servomeccanismo: a ogni fotogramma si misura dove e' finita la
    testa toccata e si corregge la differenza, finche' la chiusura non ha
    esaurito la propria corsa. Ogni correzione riporta lo scarto a zero, e il
    fotogramma dopo ne trova solo quello nuovo prodotto dall'animazione.
  */
  function ancoraTesta(testa, topIniziale) {
    var scadenza = Date.now() + CHIUDE + 80;   // la chiusura piu' lunga, piu' un margine
    function passo() {
      correggiDi(testa.getBoundingClientRect().top - topIniziale);
      if (Date.now() < scadenza) { requestAnimationFrame(passo); }
    }
    requestAnimationFrame(passo);
  }

  cassetti.forEach(function (det, i) {
    det.dataset.chiave = 'c' + i;
    var testa = det.querySelector('.ornami-cassetto__testa');
    if (!testa) return;

    testa.addEventListener('click', function (e) {
      // Si toglie al browser il cambio di stato istantaneo. L'Invio da tastiera
      // su un `<summary>` genera un evento `click`, quindi passa di qui e
      // continua a funzionare.
      e.preventDefault();

      if (det.open) { chiudi(det); return; }

      /*
        IL CASSETTO TOCCATO NON DEVE SCAPPARE DA SOTTO IL DITO.

        Chiudere il cassetto aperto piu' in alto accorcia la pagina, e tutto
        cio' che sta sotto risale della stessa quantita' - compreso quello che
        si e' appena toccato. Misurato a 390x844: la testa passava da +157 a
        -1054, uno spostamento di 1211 pixel su una finestra alta 844. Succede
        ogni volta che si scende, cioe' nel verso in cui si legge.

        Il rimedio non e' rallentare l'animazione: e' compensare lo scorrimento
        della stessa quantita' che si perde, cosi' la testa toccata resta dove
        il dito l'ha lasciata. Si misura PRIMA di chiudere e si corregge subito
        dopo, nello stesso fotogramma, perche' una correzione animata sarebbe
        essa stessa un movimento da seguire.

        Si compensa solo per i cassetti che stanno SOPRA quello toccato: quelli
        sotto, chiudendosi, non spostano nulla di cio' che gli sta sopra.
      */
      var primaTesta = testa.getBoundingClientRect().top;
      var chiusoQualcosaSopra = false;

      for (var j = 0; j < cassetti.length; j++) {
        if (cassetti[j] !== det && cassetti[j].open) {
          if (j < i) { chiusoQualcosaSopra = true; }
          chiudi(cassetti[j]);
        }
      }
      apri(det);

      if (chiusoQualcosaSopra) { ancoraTesta(testa, primaTesta); }
    });
  });
})();

/*
  Il paragrafo dell'attacco che si accende allo scorrimento.

  Stesso calcolo di progresso di `sections/murals-main-description.liquid`
  (posizione del blocco nel viewport -> quante parole risultano "accese"), con
  una differenza decisiva: qui la classe non si toglie MAI tornando indietro.
  Un paragrafo giustificato e' un blocco che si legge una volta e resta letto,
  non un contatore che deve poter tornare a zero - la cumulativita' e' cio' che
  rende l'effetto calmo invece che nervoso.

  IIFE indipendente da quella sopra: questo blocco esiste anche su una pagina
  che avesse un paragrafo senza cassettiera, e viceversa.
*/
(function () {
  var lead = document.querySelector('[data-lead]');
  if (!lead) return;

  var lettere = [].slice.call(lead.querySelectorAll('.ornami-archivio__lettera'));
  if (!lettere.length) return;

  function motoRidotto() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Il testo non deve mai dipendere da uno scorrimento per essere leggibile.
  if (motoRidotto()) {
    lettere.forEach(function (l) { l.style.opacity = '1'; });
    return;
  }

  /*
    UN FRONTE SFUMATO AGGANCIATO ALLO SCORRIMENTO.

    Il meccanismo precedente aveva una RIGA DI LETTURA al 70% dell'altezza:
    ogni parola che la attraversava riceveva una classe e partiva una
    transizione di 360ms. Funzionava, ma aveva due limiti strutturali, e sono
    proprio i due che si vedono mettendo le due pagine una accanto all'altra.

      1. L'unita' era la PAROLA, quindi fra spento e acceso esistevano due
         soli valori. Il fronte non poteva essere sfumato: era un bordo.

      2. L'accensione era GUIDATA DAL TEMPO. Superata la riga, ogni parola
         correva per conto suo anche a dito fermo. La referenza fa il
         contrario, ed e' misurato: fermando lo scorrimento e campionando tre
         volte a 700ms di distanza, il suo fronte resta immobile al carattere
         86. La posizione del fronte e' una funzione pura dell'offset, quindi
         chi scorre non innesca la rivelazione: la CONDUCE. E' quella la
         differenza che si sente e che non si sa nominare - manipolazione
         diretta invece di animazione innescata.

    Qui il fronte e' una posizione in caratteri, ricavata da quanto il blocco
    ha attraversato la finestra. Ogni lettera prende un'opacita' continua in
    base alla propria distanza dal fronte, su una finestra di NOVE caratteri:
    la stessa larghezza misurata sulla referenza. La transizione CSS da 150ms
    non fa il movimento, smussa soltanto il salto fra un fotogramma e l'altro.

    NON e' piu' cumulativo: vedi il commento su `disegna()`. Il testo si
    riaccende salendo e si rispegne tornando indietro.
  */
  var FINESTRA = 9;      // caratteri di sfumatura del fronte
  /*
    IL FRONTE PARTE QUANDO SI COMINCIA A LEGGERE, non quando il blocco appare.

    Con 0,92 il fronte era gia' partito a schermo fermo: su telefono, a offset
    zero, quattro lettere risultavano accese. "Un b" si leggeva come un
    grassetto messo per sbaglio - e in un sistema dove il 600 esiste solo a
    88px, un pezzo di parola piu' scuro degli altri non ha nessuna spiegazione
    possibile se non l'errore.

    0,80 tiene il blocco intatto finche' non e' entrato per davvero; 0,45 gli
    da' una corsa piu' corta, cosi' il fronte cammina al passo della lettura
    invece di trascinarsi per tutta l'altezza della finestra.
  */
  var INIZIO = 0.80;     // il fronte parte col blocco all'80% dell'altezza
  var FINE = 0.45;       // e finisce quando il fondo del blocco e' al 45%

  /*
    LO STATO SPENTO SI LEGGE DAL CSS, non si ripete qui.

    Il valore vive nel foglio ed e' DIVERSO fra le due fasce - .50 sopra il
    breakpoint e .62 sotto, perche' a 30,6px il paragrafo e' testo grande per
    le linee guida e a 21px non lo e' piu'. Cablarlo qui avrebbe voluto dire
    tenere due numeri allineati a mano in due file, e sarebbe bastato ritoccare
    il CSS perche' il JS ripartisse da un valore che non e' quello reso: il
    fronte avrebbe avuto un gradino all'inizio.

    Si rilegge anche al `resize`: passare da una fascia all'altra cambia il
    valore di partenza.
  */
  var SPENTA = 0.5;
  function leggiSpenta() {
    // Si legge a transizione spenta e senza il valore in linea: appena messa
    // `o-rivela` la lettera sta ANDANDO verso lo spento, e il valore calcolato
    // in quell'istante sarebbe ancora 1; e dopo il primo disegno la prima
    // lettera porta l'opacita' in linea, che non e' quella del foglio.
    var l = lettere[0];
    var op = l.style.opacity;
    var tr = l.style.transition;
    l.style.transition = 'none';
    l.style.opacity = '';
    var v = parseFloat(window.getComputedStyle(l).opacity);
    l.style.opacity = op;
    void l.offsetWidth;   // il ripristino avviene ancora senza transizione
    l.style.transition = tr;
    if (!isNaN(v) && v > 0 && v < 1) { SPENTA = v; }
  }

  var N = lettere.length;
  var opacita = new Float32Array(N);   // l'ultimo valore scritto, per non riscrivere
  var frontePrec = -FINESTRA - 1;
  /*
    L'ATTENUAZIONE LA ACCENDE LO SCRIPT, non il foglio.

    A riposo il CSS tiene le lettere piene: senza JS, o finche' il JS non e'
    arrivato, il manifesto e' un paragrafo leggibile (audit 2026-09-11, I-3:
    prima restava a 0,14 per sempre). La classe `o-rivela` sul contenitore e'
    cio' che fa valere lo stato spento, e va messa PRIMA di leggerlo: senza,
    `leggiSpenta` troverebbe 1 e non ci sarebbe nessun fronte da disegnare.
  */
  lead.classList.add('o-rivela');
  leggiSpenta();
  for (var k = 0; k < N; k++) { opacita[k] = SPENTA; }

  // Accelerazione dolce in entrata e in uscita: senza, il fronte ha due
  // spigoli e si legge come una banda invece che come una sfumatura.
  function addolcisci(t) {
    return t * t * (3 - 2 * t);
  }

  function posizioneFronte() {
    var alta = window.innerHeight;
    var r = lead.getBoundingClientRect();
    // Quanto della corsa e' stato percorso: 0 quando la cima del blocco e'
    // ancora in basso, 1 quando il fondo ha superato la soglia alta.
    var da = alta * INIZIO;
    var a = alta * FINE;
    var corsa = (r.height + (da - a));
    if (corsa <= 0) return N + FINESTRA;
    var fatto = da - r.top;
    var p = fatto / corsa;
    if (p < 0) p = 0;
    if (p > 1) p = 1;
    // Il fronte deve poter uscire dai due lati, altrimenti la prima e
    // l'ultima lettera non completerebbero mai la propria sfumatura.
    return p * (N + FINESTRA * 2) - FINESTRA;
  }

  /*
    REVERSIBILE IN ENTRAMBE LE DIREZIONI, su richiesta del committente.

    Prima era cumulativo, e coincideva con la referenza. Verificato di nuovo, e
    stavolta guidando Lenis con una durata vera invece che con un salto
    immediato che il loro gestore non intercettava: su bonjour.paris, risalito
    a y=200 - ben sopra il paragrafo - tutte e 141 le lettere restano a 1. La
    referenza NON torna indietro.

    Il committente lo vuole comunque reversibile, e su una cosa ha ragione: un
    effetto che si vede una volta sola non si puo' riguardare, e in una
    presentazione e' proprio cio' che serve. L'opacita' e' quindi una funzione
    pura della posizione del fronte, in salita come in discesa.

    Con la cumulativita' sparisce anche l'ottimizzazione a finestra: se il
    valore puo' scendere, non basta piu' toccare le lettere davanti al fronte.
    Si riscrivono tutte, ma solo quelle il cui valore cambia di piu' di un
    millesimo: su cinquecento lettere i cambi per fotogramma restano poche
    decine.
  */
  function disegna() {
    var f = posizioneFronte();
    if (f === frontePrec) return;
    for (var k = 0; k < N; k++) {
      var t = (f - k) / FINESTRA;
      if (t < 0) t = 0; else if (t > 1) t = 1;
      var v = SPENTA + (1 - SPENTA) * addolcisci(t);
      if (Math.abs(v - opacita[k]) < 0.001) continue;
      opacita[k] = v;
      lettere[k].style.opacity = v >= 0.999 ? '1' : v.toFixed(3);
    }
    frontePrec = f;
  }

  /*
    Il freno resta un orologio e non `requestAnimationFrame`: la rivelazione
    non deve dipendere da un secondo meccanismo per completarsi, e il primo
    colpo deve passare subito perche' chi scorre non aspetta un fotogramma.
    L'ultimo evento di una raffica e' comunque richiamato in coda.
  */
  var PASSO_FRENO = 16;
  var atteso = false;
  var ultimo = 0;

  function chiedi() {
    var ora = Date.now();
    if (ora - ultimo >= PASSO_FRENO) { ultimo = ora; disegna(); return; }
    if (atteso) return;
    atteso = true;
    setTimeout(function () {
      atteso = false;
      ultimo = Date.now();
      disegna();
    }, PASSO_FRENO);
  }

  /*
    SI PARTE A DOM PRONTO, non a `load`.

    `load` aspetta l'ambientazione a 2400px e il ritratto: su rete lenta il
    paragrafo restava spento per tutto quel tempo (audit 2026-09-11, I-3).
    Questo file e' `defer`, quindi il DOM c'e' gia' e `DOMContentLoaded` puo'
    essere passato: si controlla `readyState` e non si aspetta un evento che
    potrebbe non arrivare piu'.

    `load` + 500ms resta come RIPASSO, non come partenza: Locomotive puo'
    aver spostato il contenuto dopo il primo disegno, e l'aggancio a
    `scroll.on` si ritenta li' se `scroll` non esisteva ancora.
  */
  var agganciato = false;
  function aggancia() {
    if (agganciato) return false;
    if (typeof scroll !== 'undefined' && scroll && typeof scroll.on === 'function') {
      scroll.on('scroll', chiedi);
      agganciato = true;
    }
    return agganciato;
  }

  function avvia() {
    aggancia();
    window.addEventListener('scroll', chiedi, { passive: true });
    // Ruotare il telefono cambia `innerHeight`, quindi cambia la corsa.
    window.addEventListener('resize', function () {
      // Cambiare fascia cambia lo stato spento reso dal CSS.
      leggiSpenta();
      chiedi();
    });
    leggiSpenta();
    disegna();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }

  window.addEventListener('load', function () {
    setTimeout(function () {
      aggancia();
      leggiSpenta();
      frontePrec = -FINESTRA - 1;   // forza il ridisegno anche a fronte fermo
      disegna();
    }, 500);
  });
})();

/*
  L'ARRIVO DEI CASSETTI - uno dopo l'altro, a gruppi.

  Il CSS (`.ornami-cassetto.o-attende` in common.css) descrive i due stati:
  in attesa e arrivato. Qui si decide CHI aspetta e QUANDO arriva.

  Perche' non `data-scroll` di Locomotive, che marca `is-inview` da solo: la
  ragione e' lo sfasamento. Sei cassetti che entrano insieme devono partire a
  70ms l'uno dall'altro, ma un cassetto che entra da solo dopo uno scorrimento
  non deve aspettare nessuno. Locomotive non sa quali entrano insieme;
  l'IntersectionObserver si': le voci che consegna nella stessa chiamata sono
  quelle comparse nello stesso fotogramma, e il ritardo si conta li' dentro.

  Solo i cassetti SOTTO la piega al caricamento aspettano: quelli gia' in
  vista sono arrivati con la pagina, e spegnerli per riaccenderli sarebbe un
  lampeggio. Senza osservatore, o con movimento ridotto, non si mette niente
  e le righe sono piene da subito - lo stato di riposo del CSS e' quello.
*/
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var righe = [].slice.call(document.querySelectorAll('[data-cassetto]'));

  var PASSO = 70;      // fra un cassetto e il successivo dello stesso gruppo
  var SOGLIA = 0.9;    // sotto il 90% dell'altezza della finestra = sotto la piega

  var attese = righe.filter(function (det) {
    return det.getBoundingClientRect().top > window.innerHeight * SOGLIA;
  });
  if (attese.length) {
    attese.forEach(function (det) { det.classList.add('o-attende'); });
    var oss = new IntersectionObserver(function (voci) {
      var k = 0;
      voci.forEach(function (v) {
        if (!v.isIntersecting) return;
        v.target.style.setProperty('--o-ritardo', (k * PASSO) + 'ms');
        v.target.classList.add('is-inview');
        oss.unobserve(v.target);
        k++;
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
    attese.forEach(function (det) { oss.observe(det); });

    /*
      LA RETE SOTTO LA RETE. Un cassetto in attesa e' a opacita' .45: se
      l'osservatore non consegna mai - pannello non renderizzato, scheda in
      secondo piano al caricamento, scorrimento programmatico che non produce
      intersezioni - resterebbe dimezzato per sempre, e sono i sei nomi del
      catalogo. Verificato: in un browser con il pannello nascosto, dopo lo
      scorrimento e 900ms i primi tre stavano ancora a .45.

      Quindi, in ogni caso, dopo quattro secondi dal caricamento ogni cassetto
      ancora in attesa si accende da solo, senza stagger. Quattro secondi sono
      abbastanza perche' l'ingresso coreografato abbia avuto la sua occasione,
      e poco abbastanza perche' nessuno resti davanti a un elenco spento.
    */
    setTimeout(function () {
      attese.forEach(function (det) {
        if (!det.classList.contains('is-inview')) {
          det.style.setProperty('--o-ritardo', '0ms');
          det.classList.add('is-inview');
          oss.unobserve(det);
        }
      });
    }, 4000);
  }

  /*
    LE PORTE HANNO GIA' IL LORO INNESCO (Locomotive, `data-scroll`), e qui si
    aggiunge solo una RETE: lo stesso osservatore mette la stessa classe. Se
    Locomotive la mette prima, questa e' un'operazione vuota; se non la mette
    mai - e' successo - le porte arrivano lo stesso. Il ritardo fra le due
    resta quello inline (`--o-porta-ritardo`), non si tocca.
  */
  var porte = [].slice.call(document.querySelectorAll('.ornami-porta[data-scroll]'));
  if (porte.length) {
    var rete = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) {
        if (!v.isIntersecting) return;
        v.target.classList.add('is-inview');
        rete.unobserve(v.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
    porte.forEach(function (a) { rete.observe(a); });
  }
})();

/*
  LO SCORRI DELL'ATTACCO. Un bottone con l'anello di testo che ruota: al clic
  porta alla prima cosa dopo l'attacco - l'ambientazione - con lo scorrimento
  di Locomotive, che e' l'unico a muovere davvero la pagina (window.scrollTo
  qui non fa nulla). Se Locomotive non c'e', si ripiega su scrollIntoView,
  che in quel caso funziona perche' il contenitore non e' trasformato.
*/
(function () {
  var scorri = document.querySelector('[data-ornami-scorri]');
  if (!scorri) return;
  var meta = document.querySelector('.ornami-archivio__figura') || document.querySelector('.ornami-archivio__cassetti');
  if (!meta) return;
  scorri.addEventListener('click', function () {
    if (window.scroll && typeof window.scroll.scrollTo === 'function') {
      window.scroll.scrollTo(meta, { offset: -40, duration: 900 });
    } else {
      meta.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();
